import * as types from './constants';

const initialState = {
  unreadMessagesCount: null
};

const actions = {
  // SendBird Unread Messages
  [types.SET_SENDBIRD_UNREAD_MESSAGES]: (state, { payload }) => {
    const data = {
      ...state,
      unreadMessagesCount: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

